export const convertHtmlToText = (html: string) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  const text = tempDiv.textContent || tempDiv.innerText || "";
  return text;
};
